import React from "react";

export default function Navbar() {
  const navbarBrandStyle = {
    fontFamily: 'Garamond, serif',
    fontSize: '1.75rem',
    color: '#1d1e1e',
    margin: 0,
    // display: 'flex', <--- Remove this, handled by logoBrandContainer
    // alignItems: 'center', <--- Remove this
  };
  const navbarStyle = {
    minHeight: '60px',
    display: 'flex',
    alignItems: 'center',
    paddingTop: '5px',
    paddingBottom: '5px',
  };
  const logoStyle = {
    height: 'auto',
    width: 'clamp(50px, 6vw, 60px)',
  };
  const logoBrandContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    
    flexShrink: 0, // Prevent container from shrinking
  };
  const containerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light " style={navbarStyle}>
        <div style={containerStyle}>
          <div style={logoBrandContainerStyle}>
            <img src="/thedata/LogoTDRS.png" alt="Logo" style={logoStyle} />
            <h2 style={navbarBrandStyle}>The Dry Fruit Shop</h2>
          </div>
        </div>
      </nav>
    </div>
  );
}
